import moment from "moment";

const methods = {
  isoDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("YYYY-MM-DD");
      return local;
    }
    return "";
  },
  normalDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MM/DD/YYYY");
      return local;
    }
    return "";
  },
  normalDateNoTz(date) {
    if (date) {
      var local = moment(date).format("MM/DD/YYYY");
      return local;
    }
    return "";
  },
  longDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MMMM DD, YYYY");
      return local;
    }
    return "";
  },
  longDateWithTime(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MMMM DD, YYYY [at] hh:mm A");
      return local;
    }
    return "";
  },
  longDateNoTz(date) {
    if (date) {
      var local = moment(date).format("MMMM DD, YYYY");
      return local;
    }
    return "";
  },
  dateWithDowNoTz(date) {
    if (date) {
      var local = moment(date).format("dddd, MMMM Do");
      return local;
    }
    return "";
  },
  time(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("hh:mm A");
      return local;
    }
    return "";
  },
  timeWithSeconds(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("HH:mm:ss");
      return local;
    }
    return "";
  },
  year(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("YYYY");
      return local;
    }
    return "";
  },
  monthDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MMMM Do");
      return local;
    }
    return "";
  },
  monthDateNoTz(date) {
    if (date) {
      var local = moment(date).format("MMMM Do");
      return local;
    }
    return "";
  },
  monthYearNoTz(date) {
    if (date) {
      var local = moment(date).format("MMMM YYYY");
      return local;
    }
    return "";
  }
};

export default methods;
